// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TasksSummaryHeaderQueryVariables = Types.Exact<{
  taskIntervalEnd: Types.Scalars['Date']['input'];
  taskIntervalStart: Types.Scalars['Date']['input'];
  projectStatus?: Types.InputMaybe<Array<Types.ProjectStatus> | Types.ProjectStatus>;
}>;


export type TasksSummaryHeaderQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', id: string, interval: { __typename?: 'CalendarInterval', endDate: Types.Scalars['Date']['input'], startDate: Types.Scalars['Date']['input'] } }> };

export type TasksSummaryHeaderDetailsFragment = { __typename?: 'Task', id: string, interval: { __typename?: 'CalendarInterval', endDate: Types.Scalars['Date']['input'], startDate: Types.Scalars['Date']['input'] } };

export const TasksSummaryHeaderDetailsFragmentDoc = gql`
    fragment TasksSummaryHeaderDetails on Task {
  id
  interval {
    endDate
    startDate
  }
}
    `;
export const TasksSummaryHeaderDocument = gql`
    query TasksSummaryHeader($taskIntervalEnd: Date!, $taskIntervalStart: Date!, $projectStatus: [ProjectStatus!]) {
  tasks(
    filter: {myTasks: true, projectStatus: $projectStatus, status: [NOT_STARTED, IN_PROGRESS, ON_HOLD, DELAYED], startDateRange: {op: ON_OR_BEFORE, value: $taskIntervalEnd}, endDateRange: {op: ON_OR_AFTER, value: $taskIntervalStart}}
  ) {
    ...TasksSummaryHeaderDetails
  }
}
    ${TasksSummaryHeaderDetailsFragmentDoc}`;

/**
 * __useTasksSummaryHeaderQuery__
 *
 * To run a query within a React component, call `useTasksSummaryHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksSummaryHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksSummaryHeaderQuery({
 *   variables: {
 *      taskIntervalEnd: // value for 'taskIntervalEnd'
 *      taskIntervalStart: // value for 'taskIntervalStart'
 *      projectStatus: // value for 'projectStatus'
 *   },
 * });
 */
export function useTasksSummaryHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables> & ({ variables: TasksSummaryHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>(TasksSummaryHeaderDocument, options);
      }
export function useTasksSummaryHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>(TasksSummaryHeaderDocument, options);
        }
// @ts-ignore
export function useTasksSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>;
export function useTasksSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TasksSummaryHeaderQuery | undefined, TasksSummaryHeaderQueryVariables>;
export function useTasksSummaryHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>(TasksSummaryHeaderDocument, options);
        }
export type TasksSummaryHeaderQueryHookResult = ReturnType<typeof useTasksSummaryHeaderQuery>;
export type TasksSummaryHeaderLazyQueryHookResult = ReturnType<typeof useTasksSummaryHeaderLazyQuery>;
export type TasksSummaryHeaderSuspenseQueryHookResult = ReturnType<typeof useTasksSummaryHeaderSuspenseQuery>;
export type TasksSummaryHeaderQueryResult = ApolloReactCommon.QueryResult<TasksSummaryHeaderQuery, TasksSummaryHeaderQueryVariables>;